import axios from 'axios';

// Pubblicazioni presenti su Amazon/eBay senza prodotto associato da noi.
// La lista la riempie un job in background: qui si chiede solo di avviarlo e di leggerla.

const buildUrl = (context, path) => `${context.rootGetters['settings/getUrl']}marketplaceunmatched/${path}`;

const authHeader = context => ({ Authorization: `Bearer ${context.rootGetters['profile/getToken']}` });

const fail = err => {
	const detail = err?.response?.data?.error;
	return {
		error: Array.isArray(detail) ? detail.join(', ') : detail || err?.response?.status || true,
		status: err?.response?.status,
	};
};

const actions = {
	// avvia la lettura del report: risponde subito, il lavoro dura minuti
	scan: async (context, { platform, marketplace }) => {
		return await axios
			.post(buildUrl(context, `${platform}/scan`), { marketplace }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},

	// stato dell'ultima scansione: data, contatori, se e' ancora in corso
	scanStatus: async (context, { platform, marketplace }) => {
		return await axios
			.get(buildUrl(context, `${platform}/scan`), { headers: authHeader(context), params: { marketplace } })
			.then(res => res.data)
			.catch(fail);
	},

	rows: async (context, { platform, marketplace, page = 1, limit = 25, search = '', status = '' }) => {
		return await axios
			.get(buildUrl(context, `${platform}/rows`), {
				headers: authHeader(context),
				params: { marketplace, page, limit, search, status },
			})
			.then(res => res.data)
			.catch(fail);
	},

	// aggancia la pubblicazione a una variante con una scrittura sola: il salvataggio
	// completo del prodotto, su prodotti grossi, finisce in timeout
	associate: async (context, { platform, rowId, itemId, variantId }) => {
		return await axios
			.post(buildUrl(context, `${platform}/associate`), { rowId, itemId, variantId }, { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},

	// la riga sparisce dalla lista appena il prodotto viene associato
	remove: async (context, { platform, id }) => {
		return await axios
			.delete(buildUrl(context, `${platform}/rows/${id}`), { headers: authHeader(context) })
			.then(res => res.data)
			.catch(fail);
	},
};

export default {
	namespaced: true,
	actions,
};
